import React, { useState } from 'react';
import { InlineLink } from '@fullstory/components';
import { PlanContactSidecar } from '@fullstory/overlays-ui';
import { FormattedMessage } from 'react-intl';

export const useRetentionContactButton = () => {
  const [showSidecar, setShowSidecar] = useState(false);
  const contactButton = (
    <>
      <InlineLink onClick={() => setShowSidecar(true)}>
        <FormattedMessage defaultMessage="contact us" id="cZ6IMP" />
      </InlineLink>
      <PlanContactSidecar closeFn={() => setShowSidecar(false)} open={showSidecar} />
    </>
  );

  return contactButton;
};
